import moment from 'moment-timezone';
import React from 'react';
import { ValidDateFormats } from '../../Shared/DateUtilities';
import styles from './Header.module.scss';

const Title: React.FC<{
    label: string;
}> = props => {
    return (
        <div className={styles.header}>
            <div className={styles.display}>{props.label}</div>
        </div>
    );
};

const InfoLine: React.FC<{
    /**
     * Expected to be a Date Time Iso
     */
    createdOn: string;
    /**
     * Expected to be a Date Time Iso
     */
    updatedOn: string;
    updatedBy: string;
}> = props => {
    const updatedOn = moment(props.updatedOn).fromNow();
    const createdOn = moment(props.createdOn).format(ValidDateFormats.Display);

    return (
        <div className={styles.infoContainer}>
            <div className={styles.info}>{`Created ${createdOn} · Edited by ${props.updatedBy} · ${updatedOn}`}</div>
        </div>
    );
};

export const Header: React.FC<{
    title: string;
    /**
     * Expected to be a Date Time Iso
     */
    createdOn: string;
    /**
     * Expected to be a Date Time Iso
     */
    updatedOn: string;
    updatedBy: string;
}> = props => {
    return (
        <div className={styles.stickyHeader}>
            <div className={styles.headerContainer}>
                <Title label={props.title} />
            </div>
            <InfoLine {...props} />
        </div>
    );
};
